import * as AuthActions from './auth.actions';
import { AdminUserInfo, ResendCodeInfo } from '../../shared/models/user.model';
import { CognitoUser } from 'amazon-cognito-identity-js';


export interface State {
  adminUser: AdminUserInfo | undefined;
  token: string | null;
  authenticated: boolean;
  cognitouser: CognitoUser | null;
  resendCodeInfo: ResendCodeInfo | undefined;
  confirmError: boolean | undefined;
}

const initialState: State = {
  adminUser: undefined,
  token: null,
  authenticated: false,
  cognitouser: null,
  resendCodeInfo: undefined,
  confirmError: undefined
  
  // adminUser: {} ,
  // token: '',
  // authenticated: false,
  // // cognitouser: any,
  // resendCodeInfo: {},
  // confirmError: false

};


// const reducer = createReducer(
//   initialState, AuthActions,
//   on(AuthActions.CONFIRMATION_ERROR, (state, action)=>{
//     return [...state, action.payload]
// }));

// export function authReducer(state = initialState, action: AuthActions.AuthActions) {
//   return reducer(state, action)
// }

export function authReducer(state = initialState, action: AuthActions.AuthActions): State {
  switch (action.type) {
    case (AuthActions.CONFIRM_SIGNUP):
      return {
        ...state,
        authenticated: true
      };
    case (AuthActions.SET_SIGNUP_INFO):
      return {
        ...state,
        adminUser: action.payload
      };
    case (AuthActions.SIGNUP):     
    case (AuthActions.SIGNIN):
      return {
        ...state,
        cognitouser: action.payload
      };
    case (AuthActions.SET_RESEND_CODE_INFO):
      return {
        ...state,
        resendCodeInfo: action.payload
      };
    case (AuthActions.CONFIRMATION_ERROR):
      return {
        ...state,
        confirmError: action.payload
      };
      default:
        return state;

        
  }
}